(function () {
  'use strict';

  var COOKIE_NAME = 'cwc_age_verified';
  var COOKIE_DAYS = 30;
  var LOCK_CLASS = 'cwc_age-gate-locked';

  function setVerified() {
    var maxAge = COOKIE_DAYS * 24 * 60 * 60;
    document.cookie = COOKIE_NAME + '=1; max-age=' + maxAge + '; path=/; SameSite=Lax';
  }

  function setPageInert(isInert) {
    var page = document.querySelector('.page');
    if (!page) return;
    if (isInert) {
      page.setAttribute('inert', '');
      page.setAttribute('aria-hidden', 'true');
    } else {
      page.removeAttribute('inert');
      page.removeAttribute('aria-hidden');
    }
  }

  function focusFirstButton(gate) {
    var view = gate.querySelector('.cwc_age-gate__view--' + gate.dataset.view);
    var button = view ? view.querySelector('button') : null;
    if (button) button.focus({ preventScroll: true });
  }

  function showView(gate, view) {
    gate.dataset.view = view;
    focusFirstButton(gate);
  }

  function initGate(gate) {
    if (!gate || gate.dataset.ageGateReady) return;
    gate.dataset.ageGateReady = 'true';

    setPageInert(true);
    focusFirstButton(gate);

    var approve = gate.querySelector('[data-age-gate-approve]');
    var decline = gate.querySelector('[data-age-gate-decline]');
    var back = gate.querySelector('[data-age-gate-return]');

    if (approve) {
      approve.addEventListener('click', function () {
        setVerified();
        setPageInert(false);
        document.documentElement.classList.remove(LOCK_CLASS);
        gate.parentNode.removeChild(gate);
      });
    }

    if (decline) {
      decline.addEventListener('click', function () {
        showView(gate, 'declined');
      });
    }

    if (back) {
      back.addEventListener('click', function () {
        showView(gate, 'question');
      });
    }

    // Keep keyboard focus inside the gate
    gate.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        event.preventDefault();
        return;
      }
      if (event.key !== 'Tab') return;

      var view = gate.querySelector('.cwc_age-gate__view--' + gate.dataset.view);
      var focusable = view ? view.querySelectorAll('button, a[href]') : [];
      if (!focusable.length) return;

      var first = focusable[0];
      var last = focusable[focusable.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });
  }

  function init() {
    initGate(document.getElementById('cwc_age-gate'));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
